import { type IDataObjectsState } from '@inpart-io/devtools-vue';
import { type AccessControlManager, type IDataObjectAccessControl } from '@inpart-io/padme-iap';
import { type Module } from 'vuex';

import { getActions } from './actions';

export function getAccessControlModule<T extends IDataObjectAccessControl>(manager: AccessControlManager<T>): Module<IDataObjectsState<T>, unknown> {
    return {
        namespaced: true,
        actions: getActions<T>(manager)
    };
}
